import React, { useState, useEffect} from "react";
import axios from "axios";
import { LoyaltyTwoTone } from "@material-ui/icons";
import {
	FormGroup,
	FormLabel,
	FormControl,
	FormHelperText,
	NativeSelect,
	// ListItemText,
	TextField,
	// Checkbox,
	// FormControlLabel,
	Select,
	Input,
	InputLabel,
	TableSortLabel,
	MenuItem,
	Modal,
	Backdrop,
	//Fade,
	fade,
	Button,
	Grid,
	Card,
	CardContent,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { format } from "date-fns";
import DateFnsUtils from "@date-io/date-fns";
import {
	MuiPickersUtilsProvider,
	KeyboardTimePicker,
	KeyboardDatePicker,
} from "@material-ui/pickers";
import { NavLink } from "react-router-dom";

//Material UI Icons
import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

//cookies
import {get_cookies, isLoggedIn} from "../../components/Cookies/Cookies";
import Preloader from "../../components/Preloader/Preloader";

const useStyles = makeStyles({
	title: {
		marginTop: 0,
	},
	field: {
		width: "100%",
		marginBottom: "1rem",
	},
	autoComplete: {
		width: "100%",
		marginTop: "0",
		marginBottom: "0.5rem",
	},
	date: {
		width: "100%",
		marginBottom: "1rem",
	},
	buttonContainer: {
		textAlign: "right",
	},
	root: {
		'&$disabled': {
		  color: '#f2f2f2',
		},
	  },
	disabled: {},
});

const PurchaseOrderCYOP = () => {
	const classes = useStyles();
	const [supplier, setSupplier] = useState(null);
	const [warehouse, setWarehouse] = useState(null);
	const [supplierFilter, setSupplierFilter] = useState([]);
	const [promo, setPromo] = useState([]);
	const [freight, setFreight] = useState('');
	const [hq, setHq] = useState('');
	const [wholeSaleType, setWholeSaleType] = useState([])
	const [warehouseFilter, setWarehouseFilter] = useState(null);
	const [branchIdNo, setBranchIdNo] = useState(get_cookies('branchidno'));

	const [btnDisabled, setBtnDisabled] = useState(true);
 
        const frieghtList =[
                { value: 'nofreight', label: 'Freight Collect/Pick Up' },
                { value: 'withfreight', label: 'Include Freight Charge' }
              ];
        
	const selectSupplierProps = {
		options: supplier,
		getOptionLabel: (option) => option.description,
	};
        const selectWholeSaleType = {
		options: wholeSaleType,
		getOptionLabel: (option) => option.packagetypename,
	};
        const selectFreight = {
		options: frieghtList,
		getOptionLabel: (option) => option.label,
	};

	const [selectedDate, setSelectedDate] = React.useState(format(new Date(), "yyyy-MM-dd"));

	const x = 0;
	useEffect(() => { //
		isLoggedIn();
	}, [x]);

	const handleDateChange = (date) => {
			date = format(date, "yyyy-MM-dd");
			setSelectedDate(date);
	};

	const selectLocationProps = {
		options: warehouse,
		getOptionLabel: (option) => option.description
	};
	
	const getSupplierList = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'/get_link_hq_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		}).then((res) => {
                      console.log('res',res);
                      
                      const addItem ={
                        hqidno:"MAINOFFICE",
                        description:"MAIN OFFICE"
                      }

                        setSupplier([...res.data.data,addItem]);
                      });
		
	}
        const getPromotype = async () => {
		const result = await axios.get(process.env.REACT_APP_API_URL+'/get_wholesaleset_list', {
			params:{
				jc_user_id_no: branchIdNo,  //branchIdNo
			}
		}).then((res) => {
                      console.log('res',res);
                        setWholeSaleType(res.data.data);
                      });
		
	}

	const setSupplierDetails = (supplier_object) => {
		//update value of supplier address, etc
		setSupplierFilter(supplier_object); //id filter for PO = supplier_object.id (since its an object)
		//display contanct number, customer address and mode of payment

	}
	const ColorButton = withStyles(() => ({
		root: {
		  color: "#fff",
		  backgroundColor: "#4caf50",
		  '&:hover': {
			backgroundColor: "#fff",
			color: "#4caf50",
		  }
		},
	  }))(Button);
	// componentDidMount / document.ready ?
	useEffect(() => {
			data();
	}, []);

	useEffect(() => {
		if (promo && freight && selectedDate) {
			setBtnDisabled(false); // re-enable
		} else {
			setBtnDisabled(true); // re-enable
		}
	}, [promo, freight, selectedDate]);

	const data = async () => {
		//get data for location/warehouse dropdown
		const res = await axios.get(process.env.REACT_APP_API_URL+'/get_warehouse_list');
		setWarehouse(res.data.data);
		getSupplierList();
                getPromotype();
	};

	return (
		<div className="page">
			<div className="page-header">
				<div className="page-icon">
					<LoyaltyTwoTone />
				</div>
				<NavLink to={"/purchases"}><h4 style={{color:"#339933"}}>Purchases</h4></NavLink>
				<ArrowForwardIosIcon  fontSize="small" color="disabled"/>
				<h4>Purchase Order (Choose your own package)</h4>
			</div>

		{supplier&&warehouse ? (<div className="page-container">
				<Grid container spacing={3} justifyContent="center">
					<Grid item xs="12" sm="6">
						<Card>
							<CardContent>
								<h4 className={classes.title}>Transaction information</h4>
								<form noValidate autoComplete="off">
                                                                <MuiPickersUtilsProvider
										utils={DateFnsUtils}
									>
										<KeyboardDatePicker
											disableToolbar
											variant="inline"
											format="MMM dd, yyyy"
											id="trandate"
											label="Date"
                                                                                        disabled={true}
											value={selectedDate}
											onChange={handleDateChange}
											inputVariant="outlined"
											margin="normal"
											className={classes.date}
											KeyboardButtonProps={{
												"aria-label": "change date",
											}}
											inputProps={{readOnly:"true"}}
										/>
									</MuiPickersUtilsProvider>
									<Autocomplete
										{...selectSupplierProps}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Purchase From"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												console.log(newValue);
												setSupplierFilter(newValue);
											}else{
												//console.log('hehe');
												setSupplierFilter(null);
											}
										}}
									/>
                                                                        									<Autocomplete
										{...selectWholeSaleType}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Select Promo type"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												console.log(newValue);
												setPromo(newValue.id);
											}else{
												//console.log('hehe');
												setPromo(null);
											}
										}}
									/>
                                                                                                                                                									<Autocomplete
										{...selectFreight}
										id="auto-complete"
										autoComplete
										includeInputInList
										className={classes.autoComplete}
										renderInput={(params) => (
											<TextField
												{...params}
												label="Freight"
												margin="normal"
												variant="outlined"
											/>
										)}
										onChange={(event, newValue) => {
											if (!newValue == "" || !newValue == null){
												console.log(newValue);
												setFreight(newValue.value);
											}else{
												//console.log('hehe');
												setFreight(null);
											}
										}}
									/>
									
								</form>
							</CardContent>
						</Card>
					</Grid>
		
					<Grid item xs="12" className={classes.buttonContainer}>
						{btnDisabled ? (<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    					root: classes.root, 
       			 		disabled: classes.disabled}}>
								Next
							</ColorButton>) : (<NavLink to={"/purchases/purchases-order-cyop-information/"+supplierFilter.hqidno+"/"+freight+"/"+promo+"/"+selectedDate}>
							<ColorButton disabled={btnDisabled} variant="contained" color="primary" classes={{
    					root: classes.root, 
       			 		disabled: classes.disabled}}>
								Next
							</ColorButton>
						</NavLink>)}
					</Grid>
				</Grid>
			</div>) : (<Preloader />)}

		</div>
	);
};
export default PurchaseOrderCYOP;
